export default __webpack_public_path__ + "static/media/noadsherelogo.acf2e5a8.jpg";